export const VendorErrorImpactedComponent = {
  CONTROLLER: 'controller',
  PILOT_SIGNAL_CIRCUIT: 'pilot_signal_circuit',
  FIRMWARE: 'firmware',
  TEMPERATURE_SENSOR: 'temperature_sensor',
  ENERGY_METER: 'energy_meter',
  HUMIDITY_SENSOR: 'humidity_sensor',
  MICROCOMPUTER: 'microcomputer',
  DISPLAY_SCREEN: 'display_screen',
  LED_STATUS_INDICATORS: 'led_status_indicators',
  PUSH_BUTTON: 'push_button',
  KEYPAD: 'keypad',
  ROTARY_SWITCH: 'rotary_switch',
  AUTHENTICATION_MODULE: 'authentication_module',
  BUZZER: 'buzzer',
  PAYMENT_TERMINAL: 'payment_terminal',
  POWER_LINE_COMMUNICATION_MODULE: 'power_line_communication_module',
  NETWORK_INTERFACE: 'network_interface',
  INTERNAL_BUS: 'internal_bus',
  GATEWAY_MODULE: 'gateway_module',
  POWER_CONNECTOR: 'power_connector',
  CONTACTOR: 'contactor',
  POWER_MODULE: 'power_module',
  AC_DC_CONVERTER: 'ac_dc_converter',
  TRANSFORMER: 'transformer',
  MAIN_ISOLATOR: 'main_isolator',
  BATTERY: 'battery',
  FUSE: 'fuse',
  CIRCUIT_BREAKER: 'circuit_breaker',
  SURGE_PROTECTIVE_DEVICE: 'surge_protective_device',
  AUXILIARY_POWER_SUPPLY: 'auxiliary_power_supply',
  COOLING_FAN: 'cooling_fan',
  HEATSINK: 'heatsink',
  INTERNAL_HEATER: 'internal_heater',
  LIQUID_COOLING_UNIT: 'liquid_cooling_unit',
  COOLANT: 'coolant',
  AIR_INLET: 'air_inlet',
  AIR_FILTER: 'air_filter',
  AIR_OUTLET: 'air_outlet',
  ENCLOSURE: 'enclosure',
  CHASSIS: 'chassis',
  INLET_PLUG_DOCK: 'inlet_plug_dock',
  GLANDS_SEALS: 'glands_seals',
  CABLE_RETRACTOR: 'cable_retractor',
  DOOR: 'door',
  LOCK_MECHANISM: 'lock_mechanism',
  MOUNTING_SYSTEM: 'mounting_system',
  OPENING_SENSOR: 'opening_sensor',
  RCD_PROTECTION: 'rcd_protection',
  GROUND_MONITOR: 'ground_monitor',
  E_STOP: 'e_stop',
  INSULATION_MONITOR: 'insulation_monitor',
  CHARGER_LOCK: 'charger_lock',
  SAFETY_INTERLOCK_CIRCUIT: 'safety_interlock_circuit',
  GRID: 'grid',
  ENVIRONMENT: 'environment',
  EV: 'ev',
  IDENTIFICATION_MEANS: 'identification_means',
  USER: 'user',
  GROUND: 'ground',
  BACKEND: 'backend',
  SITE_INFRASTRUCTURE: 'site_infrastructure',
} as const;

export type VendorErrorImpactedComponent =
  (typeof VendorErrorImpactedComponent)[keyof typeof VendorErrorImpactedComponent];
